var app = angular.module('leonardo');

/**
 * ShareDocumentController
 * 
 * Handles shared document links. When a user visits a share URL:
 * 1. The 'authenticated' parent state ensures they are logged in (redirects to login if not)
 * 2. This controller fetches the file from the authenticated API endpoint
 * 3. Triggers an immediate download of the file
 */
var ShareDocumentController = function($scope, $stateParams, $http, $window, ConfigThemeService, NotificationService) {
  var urlUuid = $stateParams.url_uuid;
  // Handle trailing slash in url_uuid
  if (urlUuid && urlUuid.endsWith('/')) {
    urlUuid = urlUuid.slice(0, -1);
  }
  
  // console.log('[ShareDocument] Controller initialized, url_uuid:', urlUuid);
  
  $scope.loading = true;
  $scope.error = null;
  $scope.fileName = 'document';

  if (!urlUuid) {
    // console.error('[ShareDocument] No url_uuid provided');
    $scope.loading = false;
    $scope.error = 'Invalid document link';
    return;
  }

  // Fetch the file from the authenticated API endpoint
  var apiUrl = ConfigThemeService.generateURL('/api/2.0/document-file/' + urlUuid + '/');
  // console.log('[ShareDocument] Fetching from:', apiUrl);

  $scope.retryDownload = function() {
    // console.log('[ShareDocument] Retrying download for url_uuid:', urlUuid);
    $scope.loading = true;
    $scope.error = null;
    $scope.downloadComplete = false;
    
    // Re-execute the download request
    $http({
      method: 'GET',
      url: apiUrl,
      responseType: 'blob'
    }).then(function(response) {
      // console.log('[ShareDocument] Response received, status:', response.status);
      $scope.loading = false;
      
      // Extract filename from Content-Disposition header if available
      var contentDisposition = response.headers('Content-Disposition');
      if (contentDisposition) {
        var matches = contentDisposition.match(/filename="?([^";\n]+)"?/);
        if (matches && matches[1]) {
          $scope.fileName = matches[1];
        }
      }

      // Create blob URL and download
      var blob = response.data;
      var blobUrl = $window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = blobUrl;
      link.download = $scope.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      $window.URL.revokeObjectURL(blobUrl);
      $scope.downloadComplete = true;
      // console.log('[ShareDocument] Download triggered for:', $scope.fileName);
    }, function(error) {
      console.error('[ShareDocument] Error:', error.status, error);
      $scope.loading = false;
      
      if (error.status === 401) {
        $scope.error = 'You do not have permission to access this document.';
      } else if (error.status === 404) {
        $scope.error = 'This document could not be found.';
      } else {
        $scope.error = 'An error occurred while downloading the document.';
      }
      
      NotificationService.error($scope.error);
    });
  };

  $scope.goHome = function() {
    $window.location.href = '#/';
  };

  // Initial download attempt
  $http({
    method: 'GET',
    url: apiUrl,
    responseType: 'blob'
  }).then(function(response) {
    // console.log('[ShareDocument] Response received, status:', response.status);
    $scope.loading = false;
    
    // Extract filename from Content-Disposition header if available
    var contentDisposition = response.headers('Content-Disposition');
    if (contentDisposition) {
      var matches = contentDisposition.match(/filename="?([^";\n]+)"?/);
      if (matches && matches[1]) {
        $scope.fileName = matches[1];
      }
    }

    // Create blob URL and download
    var blob = response.data;
    var blobUrl = $window.URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = blobUrl;
    link.download = $scope.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    $window.URL.revokeObjectURL(blobUrl);
    $scope.downloadComplete = true;
    // console.log('[ShareDocument] Download triggered for:', $scope.fileName);
  }, function(error) {
    console.error('[ShareDocument] Error:', error.status, error);
    $scope.loading = false;
    
    if (error.status === 401) {
      $scope.error = 'You do not have permission to access this document.';
    } else if (error.status === 404) {
      $scope.error = 'This document could not be found.';
    } else {
      $scope.error = 'An error occurred while downloading the document.';
    }
    
    NotificationService.error($scope.error);
  });
};

app.controller('ShareDocumentController', [
  '$scope', '$stateParams', '$http', '$window', 'ConfigThemeService', 'NotificationService',
  ShareDocumentController
]);
